import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CallOfferService } from '@core/services/call-offer-service/call-offer.service';
import { EsnJobOfferService } from '@core/services/esn-job-offer-service/esn-job-offer.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dossier-candidature',
  templateUrl: './dossier-candidature.component.html',
  styleUrls: ['./dossier-candidature.component.css']
})
export class DossierCandidatureComponent {
  id = this.activatedRoute.snapshot.params['id'];
  iduser = this.activatedRoute.snapshot.params['user_id'];
  type = this.activatedRoute.snapshot.params['type'];
  applyid = this.activatedRoute.snapshot.params['applyid'];


  candidaturedetails:any
  candidaturedetailsesn:any


  constructor(
    private activatedRoute: ActivatedRoute,
    private callofferservice: CallOfferService,
    private spinner: NgxSpinnerService,
 
  ) {}
  ngOnInit() {
    this.getcandidaturebyid();
     this.getcandidaturebesoinesnbyid()
  }

  /* get job offer details */
  getcandidaturebyid() {
    this.spinner.show();
    this.callofferservice.getcandidatureById(this.iduser,this.id).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        console.log('res detail job offer', res);
        this.candidaturedetails = res.data[0];
       
        console.log('detail job offer', this.candidaturedetails);
      },
      error: () => {},
    });
  }

  getcandidaturebesoinesnbyid() {
    this.spinner.show();
    this.callofferservice.getcandidaturebesoinesnById(this.applyid).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        console.log('res detail job offer', res);
        this.candidaturedetailsesn = res.data[0];
       
        console.log('candidaturedetailsesn', this.candidaturedetailsesn);
      },
      error: () => {},
    });
  }
}
